import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import userManager from '../utils/userManager'
import React, { useEffect } from 'react'
import {LANDINGPAGE} from '../utils/constants'

const CallbackPage = (props) => {
  const successCallback = (user) => {
    // get the user's previous location, passed during signinRedirect()
    var redirectPath = user.state.path
    if (redirectPath === '/') {
      redirectPath = `/${LANDINGPAGE}`
    }
    props.dispatch(push(redirectPath))
  }

  const errorCallback = (error) => {
    props.dispatch(push('/'))
  }

  // by default userManager gets params from the current route
  // eg. 'localhost:5100/callback#token_id=...&session_state=...
  //                              ------------------------------
  // this doesn't work when using hash history as the first hash messed up the process
  // eg. 'localhost:5100/#/callback#token_id=...&session_state=...
  // need to pass the token manually to signinRedirectCallback function
  useEffect(() => {
    userManager
      .signinRedirectCallback(props.signInParams)
      .then(user => successCallback(user))
      .catch(error => errorCallback(error))
  })

  return <div>Loading...</div>
}

export default connect()(CallbackPage)
